// extracted by mini-css-extract-plugin
module.exports = {"embedLoader":"EmbedLoader_embedLoader__1sR5A"};